import React from "react";
import styles from "./styles/NumberDisplay.module.css";

export default function NumberDisplay({
  fontawesomeIcon = null,
  number = null,
  title = null,
}) {
  return (
    <div className={styles.cont}>
      <div className={styles.header}>
        <div className={styles.icon}>{fontawesomeIcon}</div> {title}
      </div>
      <div className={styles.body}>
        <div className={styles.number}>{number}</div>
      </div>
    </div>
  );
}
